function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.50861 18.9908V22.5277L10.9135 21.8498C15.9535 19.4231 19.3332 14.5305 19.3332 9.66732C19.3332 4.51925 15.1479 0.333984 9.99984 0.333984C4.85177 0.333984 0.666504 4.51925 0.666504 9.66732C0.666504 14.6484 4.5865 18.7354 9.50861 18.9908ZM2.63141 9.66731C2.63141 5.59994 5.93246 2.29888 9.99983 2.29888C14.0672 2.29888 17.3683 5.59994 17.3683 9.66731C17.3683 13.322 15.0497 17.0357 11.4735 19.2954V17.0357H9.99983C5.93246 17.0357 2.63141 13.7347 2.63141 9.66731ZM9.01731 13.5971H10.9822V15.562H9.01731V13.5971ZM9.0174 12.1234H10.9823C10.9823 11.0473 11.6809 10.4368 12.3978 9.81029C13.1535 9.14986 13.9297 8.47157 13.9297 7.21116C13.9297 5.03994 12.1711 3.28134 9.99985 3.28134C7.82862 3.28134 6.07003 5.03994 6.07003 7.21116H8.03494C8.03494 6.13046 8.91915 5.24625 9.99985 5.24625C11.0806 5.24625 11.9648 6.13046 11.9648 7.21116C11.9648 8.07495 11.3952 8.51155 10.7568 9.00088C9.94299 9.62465 9.0174 10.3341 9.0174 12.1234Z",
  fill: "#666666"
});

function SvgContactSupportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSupportIcon);
export default __webpack_public_path__ + "static/media/ContactSupportIcon.f2192f62.svg";
export { ForwardRef as ReactComponent };